import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=2093a43b"
import script from "./TaskView.vue?vue&type=script&lang=ts"
export * from "./TaskView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2093a43b')) {
      api.createRecord('2093a43b', component.options)
    } else {
      api.reload('2093a43b', component.options)
    }
    module.hot.accept("./TaskView.vue?vue&type=template&id=2093a43b", function () {
      api.rerender('2093a43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/TaskView.vue"
export default component.exports